module.exports = __webpack_public_path__ + "img/BusinessFoster.4fd1d46d.jpg";